export class DataFormatService {

    objectToQueryString(data: any, keyPrefix: string = null): string {
        let queryString = '';
        let key = keyPrefix ? `${keyPrefix}.` : '';

        Object.entries(data).forEach((item) => {
            if (item[1] !== undefined && item[1] !== null && item[1] !== '') {
                if (Array.isArray(item[1])) {
                    item[1].forEach((v, i) => queryString += `${key}${item[0]}[${i}]=${v}&`);
                } else if (typeof (item[1]) === 'object') {
                    queryString += this.objectToQueryString(item[1], `${key}${item[0]}`);
                } else
                    queryString += `${key}${item[0]}=${item[1]}&`;
            }
        });
        return queryString;
    }

    objectToFormData(data: any) {
        const form_data = new FormData();

        Object.entries(data).forEach(i => {
            if (i[1] && typeof i[1] === 'object' && !(i[1] instanceof File)) {
                Object.entries(i[1]).forEach(x => {
                    form_data.append(`${i[0]}[${x[0]}]`, x[1] as any);
                });
            }
            else if (i[1] !== undefined && i[1] !== null)
                form_data.append(i[0], i[1] as any);
        });

        return form_data;
    }
}